import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Manufacturing from "@/pages/Manufacturing";
import Capabilities from "@/pages/Capabilities";
import ProductDevelopment from "@/pages/ProductDevelopment";
import Packaging from "@/pages/Packaging";
import Quality from "@/pages/Quality";
import About from "@/pages/About";
import RequestQuote from "@/pages/RequestQuote";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SmoothScroll({ children }) {
  const lenisRef = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, syncTouch: false });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <div className="min-h-screen bg-ws-bg text-ws-text overflow-x-hidden">
          <div className="grain" />
          <ScrollTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/manufacturing" element={<Manufacturing />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/product-development" element={<ProductDevelopment />} />
              <Route path="/packaging" element={<Packaging />} />
              <Route path="/quality" element={<Quality />} />
              <Route path="/about" element={<About />} />
              <Route path="/request-a-quote" element={<RequestQuote />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
